import { applyMiddleware, createStore, type Store } from 'redux';
import { logger } from 'redux-logger';
import { thunk } from 'redux-thunk';
import { reducers as datapadReducers } from './apps/Datapad';

/**
 * Creates a redux store with the appropriate middleware
 */
export function createReduxStore(): Store {
	const middleware = applyMiddleware(thunk, logger);

	// TODO: Update to recommended replacement API(s) / patterns
	return createStore(datapadReducers, undefined, middleware);
}
